var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M283.735 375.075C293.974 382.808 302.462 392.672 304.422 405.763C305.851 423.209 303.24 436.116 291.766 449.728C283.76 458.357 273.474 463.43 261.766 464.079C245.079 464.638 233.092 460.973 220.672 449.45C210.679 438.892 207.908 427.344 208.002 413.232C208.413 399.11 214.259 388.034 224.485 378.356C241.142 364.655 265.684 363.096 283.735 375.075Z",
    fill: "#003F8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M283.735 215.075C293.974 222.808 302.462 232.672 304.422 245.763C305.851 263.209 303.24 276.116 291.766 289.728C283.76 298.357 273.474 303.43 261.766 304.079C245.079 304.638 233.092 300.973 220.672 289.45C210.679 278.892 207.908 267.344 208.002 253.232C208.413 239.11 214.259 228.034 224.485 218.356C241.142 204.655 265.684 203.096 283.735 215.075Z",
    fill: "#009A2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M283.735 55.0752C293.974 62.8078 302.462 72.6719 304.422 85.7627C305.851 103.209 303.24 116.116 291.766 129.728C283.76 138.357 273.474 143.43 261.766 144.079C245.079 144.638 233.092 140.973 220.672 129.45C210.679 118.892 207.908 107.344 208.002 93.2325C208.413 79.1101 214.259 68.0341 224.485 58.3565C241.142 44.6546 265.684 43.0958 283.735 55.0752Z",
    fill: "#003F8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.0444dc3a421ad45175c23dc95f135030.svg";
export { ForwardRef as ReactComponent };